import { render, staticRenderFns } from "./propietario-data.vue?vue&type=template&id=195f3d11&scoped=true&"
import script from "./propietario-data.vue?vue&type=script&lang=js&"
export * from "./propietario-data.vue?vue&type=script&lang=js&"
import style0 from "./propietario-data.vue?vue&type=style&index=0&id=195f3d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f3d11",
  null
  
)

export default component.exports